module.exports = __webpack_public_path__ + "img/Caret-Right.eff60362.svg";